// Upload (and version) a broker's own Credit Guide / Privacy & Disclosures PDF — stored against their workspace only.
import React, { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileCheck2, FileUp, Loader2, ExternalLink } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;
const fmt = (d) => (d ? new Date(d).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : '');

export const ComplianceUpload = ({ kind, label, current, onUploaded, disabled }) => {
  const { token } = useAuth();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData(); fd.append('kind', kind); fd.append('file', file);
    setBusy(true);
    try { const { data } = await axios.post(`${API}/api/workspaces/me/compliance/upload`, fd, { headers: { Authorization: `Bearer ${token}` } }); toast.success(`${label} uploaded (v${data.file.version})`); onUploaded?.(data.file); }
    catch (err) { toast.error(typeof err?.response?.data?.detail === 'string' ? err.response.data.detail : 'Upload failed — PDF only, max size applies'); }
    finally { setBusy(false); if (ref.current) ref.current.value = ''; }
  };
  return (
    <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50/60 p-4" data-testid={`compliance-upload-${kind}`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-bold text-slate-900">{label} (PDF)</p>
          {current ? <p className="mt-0.5 flex items-center gap-1.5 text-xs text-emerald-700" data-testid={`compliance-file-${kind}`}><FileCheck2 className="w-3.5 h-3.5" /> v{current.version} · {current.filename} · {fmt(current.uploaded_at)}
            <a href={`${API}${current.url}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-0.5 font-bold underline-offset-2 hover:underline">View <ExternalLink className="w-3 h-3" /></a></p>
            : <p className="mt-0.5 text-xs text-slate-500">Upload your own document. Your clients see this exact file in their portal.</p>}
        </div>
        <label className={`inline-flex cursor-pointer items-center gap-1.5 rounded-full bg-[#15133A] px-4 py-2 text-xs font-bold text-white ${disabled || busy ? 'opacity-50 pointer-events-none' : ''}`}>
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileUp className="w-3.5 h-3.5" />} {current ? 'Upload new version' : 'Upload PDF'}
          <input ref={ref} type="file" accept="application/pdf" className="hidden" onChange={pick} disabled={disabled || busy} data-testid={`compliance-input-${kind}`} />
        </label>
      </div>
    </div>
  );
};
